/* eslint-disable no-useless-computed-key */
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getUserId, getLoginAccessToken, storageSetItem, getAccessToken, storageRemoveItem } from './utilities';
import actions from "../layouts/Dashboard/redux/actions";
import { store } from "../redux/store";

// var firebaseConfig = {
//     apiKey: "AIzaSyDkrNXwwvsCPWwYm0i0NiD1s4RLXAwNRNg",
//     authDomain: "younote-test-eddee.firebaseapp.com",
//     projectId: "younote-test-eddee",
//     storageBucket: "younote-test-eddee.appspot.com",
//     messagingSenderId: "306633859217",
//     appId: "1:306633859217:web:65460f298bf19142e71f30",
//     measurementId: "G-9ZP1J3M208"
// };

const firebaseConfig = {
    apiKey: "AIzaSyBS-JTyM3MPvl1z6nsLCkTn5qaxsUNzglE",
    authDomain: "younote-b59ea.firebaseapp.com",
    projectId: "younote-b59ea",
    storageBucket: "younote-b59ea.firebasestorage.app",
    messagingSenderId: "472650314145",
    appId: "1:472650314145:web:b98e5f808f5c75e0c85be0",
    measurementId: "G-PCBEENQBKW"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
// export const messaging = (async () => {
//     try {
//         const isSupportedBrowser = await isSupported();
//         if (isSupportedBrowser) {
//             return getMessaging(app);
//         }
//         console.log('Firebase not supported this browser');
//         return null;
//     } catch (err) {
//         return null;
//     }
// })();

export const requestForToken = async (per) => {
    try {
        const permission = await Notification.requestPermission();
        if (per && permission === "granted") {
            window.location.reload();
        }
        if (permission === "granted") {
            const currentToken = await getToken(messaging, { vapidKey: `BBGjFqogqlpPPxuHOzWykGuGIIc-I50qT6cgGGeEl2DqyP8DFvaYTELC41LtlNXSSBE126b5Drx-ueKyQCy34Zo` });
            if (currentToken) {
                storageSetItem('deviceToken', currentToken);
            } else {
                // Show permission request UI
                console.log('No registration token available. Request permission to generate one.');
            }
        } else {
            // Show permission request UI
            storageRemoveItem('deviceToken');
            console.log('User permision denied');
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
    }
};


export const checkNavigator = () => {
    const workerFileName = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register(workerFileName, { scope: "/" }).then((reg) => {
            var serviceWorker;
            if (reg.installing) {
                serviceWorker = reg.installing;
                // console.log('Service worker installing');
            } else if (reg.waiting) {
                serviceWorker = reg.waiting;
                // console.log('Service worker installed & waiting');
            } else if (reg.active) {
                serviceWorker = reg.active;
                // console.log('Service worker active');
            }

            if (serviceWorker) {
                if (serviceWorker.state === "activated") {
                    //If push subscription wasnt done yet have to do here
                    requestForToken(false);
                    onMessageListener().then((payload) => { }).catch((err) => console.log('failed: ', err));
                }
                serviceWorker.addEventListener("statechange", function (e) {
                    if (e.target.state === "activated") {
                        requestForToken(true);
                        onMessageListener().then((payload) => { }).catch((err) => console.log('failed: ', err));
                    }
                });
            }
        }, (err) => {
            console.error('unsuccessful registration with ', workerFileName, err);
        });
    }
}



function CustomDispatch() {
    if (getLoginAccessToken() || getAccessToken()) {
        let filter = { ["and"]: [{ toUserId: getUserId() }] };
        store.dispatch({
            type: actions.NOTIFICATION_START,
            url: 'notifications',
            filter: {
                where: filter,
                order: 'id DESC',
            }
        });
    }
}

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            CustomDispatch();
            resolve(payload);
        });
    });